<template>
    <div class="navitest">
        <div class="main">
            <h3>Shopdata Startpoint {{options.location}}</h3>

            <TableView :headers="columns" :rows="store.shops" :sort="sort1" :pagination="pagination">
                <template v-slot:items="{ row }">
                    <td v-html="row.name"></td>
                    <td>{{ row.id }}</td>
                    <td>{{ row.shopnumbers }}</td>
                    <td>{{ getExit(row.shopnumbers) }}</td>
                    <td>{{ getRoutes(row.shopnumbers) }}</td>
                </template>

                <template v-slot:no-data>
                    <span>No data</span>
                </template>
            </TableView>

        </div>

    </div>

</template>

<script>
    import * as nodes from '@/nodes.js'
    import TableView from '@/components/TableView'

    export default {
        name: 'NaviTest',
        components: {TableView},
        data() {
            return {
                routes: [],
                columns: [
                    { label: 'Name', field: 'name', sortable:true, type:"String" },
                    { label: 'WP ID', field: 'name', sortable:true, type:"String" },
                    { label: 'Shop ID', field: 'name', sortable:true, type:"String" },
                    { label: 'Exit', field: 'name', sortable:true, type:"String" },
                    { label: 'Node Path', field: 'name', sortable:true, type:"String" },
                ],
                sort1:{
                    field: 'first_name',
                    order: 'asc'
                },
                pagination:{
                    itemsPerPage: 100,
                    align: 'center',
                    visualStyle: 'select'
                }

            }
        },
        props: ['store', 'options'],
        methods: {
            getExit(shopNumbers) {
                let response = [];
                let v = this;
                if (Array.isArray(shopNumbers)){
                    shopNumbers.forEach(function (shopnumber) {
                        // shopnumber =
                        if ( v.store.exits[shopnumber] ) {
                            response.push(v.store.exits[shopnumber]);
                        } else {
                            response.push('')
                        }
                    })
                } else {
                    response.push('no shop numbers');
                }
                return response;

            },
            getRoutes(shopNumbers){
                let v = this;
                let shopExits = this.getExit(shopNumbers);
                let foundRoutes = [];
                if (v.routes[shopExits[0]]){
                  return v.routes[shopExits[0]];
                } else {
                  return 'cannot be navigated'
                }

                // shopExits.forEach(function (exit) {
                //     if (v.routes[exit]){
                //         foundRoutes.push( v.routes[exit]);
                //     }
                // })
                return foundRoutes;
            },
            solve: function () {
                this.routes = nodes.navigate(this.options.location);
            },
        },
        created(){
            this.solve()
        }
    }
</script>

<style scoped lang="scss">
    .bold {
        font-weight: 700;
    }

    .table {

        border: 1px solid black;
        /*padding: 10px;*/
        font-size: 14px;

        .header.row{
            font-weight: 700;
        }
        .row {
            display: flex;
            padding: 5px;
            span {
                width: 100%;
            }
            &:nth-child(even){
                background: #efefef;
            }
        }

    }
</style>
